import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import { NavLink } from "react-router-dom";
import logo from "../../../Assets/Logo1.png";
import flag from "../../../Assets/iran.svg";
import telegram from "../../../Assets/telegram1.png";
import whatsApp from "../../../Assets/whatsapp5copy.png";

const Header = () => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    setInterval(() => setTime(new Date()), 1000);
  }, []);
  const option = {
    weekday: "long",
    hour: "numeric",
    minute: "numeric",
  };
  return (
    <>
      <div className={styles.container}>
        <NavLink to="/" className={styles.logo}>
          <img className={styles.img_res} src={logo} alt="" />
        </NavLink>
        <div>
          <div className={styles.flag}>
            <img
              className={`${styles.img_res} ${styles.img_flag}`}
              src={flag}
              alt=""
            />
          </div>
          <time className={styles.time} datetime="">
            {time.toLocaleTimeString("fa-IR", option)}
          </time>
        </div>
        <div className={styles.Social_medias}>
          <NavLink
            to="https://wa.me/985319679731"
            className={styles.logo_whatsapp}
          >
            <img className={styles.img_res} src={whatsApp} alt="" />
          </NavLink>
          <NavLink to="https://t.me/sorixpay" className={styles.logo_telegram}>
            <img className={styles.img_res} src={telegram} alt="" />
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Header;
